<template>
  <div>
    <section>
      <ManagePhonesTable
      ></ManagePhonesTable>
    </section>

    <v-divider></v-divider>

    <section>
      <ManageScannersTable
      ></ManageScannersTable>
    </section>

    <v-divider></v-divider>

    <section>
      <ManageSimTable
      ></ManageSimTable>
    </section>

  </div>
</template>

<script>
    import ManagePhonesTable from "../../util/ManageDevices/ManagePhonesTable";
    import ManageScannersTable from "../../util/ManageDevices/ManageScannersTable";
    import ManageSimTable from "../../util/ManageDevices/ManageSimTable";

    // @vuese
    // Manage Devices page that contains SIMs, Phones and Scanners tables.
    // @group ManageDevices
    export default {
        name: "ManagePhones",
        components: {ManagePhonesTable, ManageScannersTable, ManageSimTable},
        data() {
            return {
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/ManageDevices.vue